<div class="modal-header">
  <div class="title">
    <h2 class="modal-title-prefix"><span translate="ODABIRAVANSA.SINGULAR"></span></h2>
  </div>
  <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
</div>
<div class="modal-body">
  <div class="container border rounded" *ngIf="loading">
    <div class="row" style="width: 50%;height: 50%; left: 50%; top: 50%;position: relative;" >
        <div class="loader" >
          <div class="icon">
            <span class="fa fa-spinner fa-spin"></span>
          </div>
          <div class="text">
            <span>Molim, sačekajte</span>
          </div>
        </div>     
    </div>
  </div>
 
    <div class="row">
      <div class="col-md-12">
          <yt-fw-default-table-with-expand 
          *ngIf="modelData!=null && modelData.MainList!=null"         
          [Config]="Config"
          [Items]="items"
          [TableColumns]="modelData.MainList.TableColumns"      
          [Table2Columns]="[
            { Name: 'Opis', Label: 'ODABIRAVANSA.OPIS.SINGULAR', Visible: true, Width: '25%' }
            ,{ Name: 'Stopa', Label: 'ODABIRAVANSA.STOPA.SINGULAR', Type:'number', Format: '1.2-2', Visible: true, CanHide: false, Required: false, Width: '5%' }
            ,{ Name: 'UkIznos', Label: 'ODABIRAVANSA.OSNOVICA.SINGULAR', Type:'number', Format: '1.2-2', Visible: true, CanHide: false, Required: false, Width: '17.5%' }
            ,{ Name: 'IskoriscenIznos', Label: 'ODABIRAVANSA.ISKORISCENIZNOS.SINGULAR', Type:'number', Format: '1.2-2', Visible: true, CanHide: false, Required: false, Width: '17.5%' }
            ,{ Name: 'Ostalo', Label: 'ODABIRAVANSA.OSTALO.SINGULAR', Type:'number', Format: '1.2-2', Visible: true, CanHide: false, Required: false, Width: '17.5%' }
            ,{ Name: 'Iznos', Label: 'ODABIRAVANSA.IZNOS.SINGULAR', Type:'number', Format: '1.2-2', Visible: true, CanHide: false, Required: true, Width: '17.5%', FormControlName: 'Iznos' }
            ]"  
          [ModelName2] = "'OdabirDokumenata'"
          [GetName2] = "'getSumePoTarifamaByAvansId'"
          [Condensed]="CondensedTable"
          (RefreshDataClicked)="RefreshData()"
          [RowColors]="rowColors"   
          #defaultTable 
        >
        </yt-fw-default-table-with-expand>      
      </div>
    </div>
    <div class="containter">
      <div class="row">
          <div class="col-md-12">
            <div class="padding: 0.5rem">	
                <span translate="LEGENDA.SINGULAR"></span>
            </div>
            <div class="row col-md-6" *ngFor="let legend of legends">
              <div style="padding: 0.5rem; position: relative;">
                <div [style.backgroundColor]="legend.color" style="width: 1rem; height: 1rem; position: absolute;"></div>
                <div style="position: relative; left: 1rem; padding-left: 0.5rem; height: 1.25rem; line-height: 1.25 rem; font-size: 0.9rem;"><span translate={{legend.name}}></span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
  <div class="modal-footer">
<button type="submit" class="btn btn-primary" id="btnSave" (click)="Save()" [disabled]="loading || numberOfItems == 0">
  <span *ngIf="loading" class="fa fa-spinner fa-spin"></span>
  <span style="margin-left: 5px;">Sačuvaj</span>
</button>

    <button type="button" class="btn btn-secondary" id="btnClose" (click)="Close()"><span>Zatvori</span></button>
  </div>
